<template>
  <div class="mx-10 ma-5" id="calendar">
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>
    <v-row class="fill-height">
      <v-col>
        <v-card
          class="pa-5"
          :style="{ border: '1px solid var(--primary-boarder-color)' }"
        >
          <v-sheet height="75">
            <v-toolbar>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-autocomplete
                class="mt-6 input-filter"
                v-model="selectedUserIds"
                :items="userList"
                item-text="full_name"
                item-value="uuid"
                outlined
                dense
                clearable
                :search-input.sync="search"
                @update:search-input="searchChange"
                v-if="hasPermission('calendar.admin')"
                multiple
                placeholder="Select users..."
              ></v-autocomplete>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item> -->
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="var(--color-primary-blue-light-2)"
              :events="events"
              :event-color="getEventColor"
              :event-text-color="getEventTextColor"
              :type="type"
              event-margin-bottom="2"
              event-height="22"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
              flat
            >
              <template #event="{ event }">
                <v-row
                  cols="12"
                  class="d-flex align-center justify-space-between px-1 main-event-container"
                >
                  <v-col
                    :cols="hasPermission('calendar.admin') ? 5 : 6"
                    class="overflow-hidden"
                    ><p style="font-size:14px; font-weight: 500;">{{ event.name }}</p></v-col
                  >
                  <v-col
                    :cols="hasPermission('calendar.admin') ? 5 : 6"
                    class="overflow-hidden event-title-container"
                    ><p style="font-size:14px; font-weight: 400; font-style: italic;">{{ event.project_name }}</p></v-col
                  >
                </v-row>
              </template>
            </v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
              max-width="450"
              min-width="450"
              :rounded="true"
            >
              <v-card
                flat
                :style="{ border: '1px solid var(--primary-boarder-color)' }"
                max-width="450"
                min-width="450"
              >
                <v-toolbar dense outlined rounded shaped flat prominent>
                  <v-col>
                    <v-toolbar-title
                      v-html="selectedEvent.name"
                    ></v-toolbar-title>
                    <v-toolbar-title
                      class="text-body-2"
                      v-html="selectedEvent.project_name"
                    ></v-toolbar-title>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="taskInfo" :color="selectedEvent.color">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-col>
                  <v-card-text>
                    <span v-html="selectedEvent.details"></span><br /><br />
                    Start - <span v-html="selectedEvent.start_date"></span> -
                    <span v-html="selectedEvent.start_time"></span><br />
                    Deadline - <span v-html="selectedEvent.due_date"></span> -
                    <span v-html="selectedEvent.due_time"></span>
                  </v-card-text>
                  <v-row cols="12" class="mt-2 mx-1">
                    <v-col
                      cols="6"
                      v-for="(assignee, index) in selectedEvent.assignee"
                      :key="index"
                    >
                      <v-chip link pill color="white">
                        <v-avatar left>
                          <v-img
                            v-if="assignee.profile_image"
                            :src="assignee.profile_image"
                          ></v-img>
                          <v-img v-else :src="defaultImage"></v-img>
                        </v-avatar>
                        <p class="truncate-name">{{ assignee.name }}</p>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>

                <v-card-actions>
                  <v-btn
                    text
                    :color="selectedEvent.color"
                    @click="selectedOpen = false"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.truncate-name {
  max-width: 135px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import { CalendarService } from "@/services/calendar-service.js";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert";
import router from "@/router";
import { EmployerService } from "@/services/employer-service.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { getStatusColors } from "@/utility/statusColors.js";

export default {
  components: { Alert },
  data: () => ({
    defaultImage: require("@/assets/img/avatar.svg"),
    focus: new Date(),
    type: "month",
    loading: false,
    errors: null,
    taskList: [],
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [],
    names: [],
    userList: [{ name: "tharindu" }, { name: "darshana" }],
    page: 1,
    search: "",
    selectedUserIds: [],
  }),
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    if (this.hasPermission("calendar.admin")) {
      this.getUserList();
      this.filterByAssignee(null);
    } else if (this.hasPermission("calendar.member")) {
      this.getTaskList();
    }

    this.$refs.calendar.checkChange();
    this.$store.dispatch("auth/getProfile");
  },
  watch: {
    selectedUserIds: {
      handler(newVal) {
        this.filterByAssignee(newVal);
      },
      deep: true,
    },
    search() {
      this.page = 1;
      this.getUserList();
    },
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    getEventTextColor(event) {
      return event.event_text_color;
    },
    setToday() {
      this.focus = new Date();
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      function getOrdinalSuffix(number) {
        const suffixes = ["th", "st", "nd", "rd"];
        const v = number % 100;
        return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
      }
      const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
      return formattedDate;
    },
    formatTime(timeString) {
      const [hours, minutes] = timeString.split(":");
      let hour = parseInt(hours, 10);
      const amPm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12;
      const formattedTime = `${hour}:${minutes} ${amPm}`;

      return formattedTime;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange() {
      const events = [];

      this.taskList.forEach((task) => {
        let color = getStatusColors(task.status);

        events.push({
          name: task.task_title,
          start_time: this.formatTime(task.start_time),
          due_time: this.formatTime(task.due_time),
          start: new Date(task.start_at),
          start_date: this.formatDate(task.start_at),
          due_date: this.formatDate(task.due_at),
          end: new Date(task.due_at),
          color: color.chip,
          event_text_color:color.text,
          timed: false,
          details: task.description,
          uuid: task.uuid,
          status: task.status,
          project_name: task.project_name,
          assignee: task.members,
        });
      });

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getTaskList() {
      this.loading = true;
      this.onDismissed();
      CalendarService.getUserTasksList()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.taskList = response.data.tasks;
            this.updateRange();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getUserList() {
      this.loading = true;
      EmployerService.getEmployerList((this.search = ""), this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.userList = response.data.data;
          }
        })
        .catch((error) => {
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    filterByAssignee(assigneeId) {
      if (Array.isArray(assigneeId) && assigneeId.length === 0) {
        assigneeId = null;
      }
      this.loading = true;
      CalendarService.getTasksByAssignee(assigneeId)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.taskList = response.data.tasks;
            this.updateRange();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    taskInfo() {
      router.push({
        name: "TaskInfo",
        params: { uuid: this.selectedEvent.uuid },
      });
    },
    onDismissed() {
      this.errors = null;
    },
    searchChange(searchText) {
      this.search = searchText;
    },
  },
};
</script>
